/**
 * @name JobService
 * @description Servicio para gestionar los puestos en Administración
 * @author Alexis Becerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Consulta los puestos de una empresa
 * Cualquier usuario con acceso a Talentry puede consultar este servicio
 * @param {any} request filter { puesto, codigo, estatus, columns }
 * @return {any} promise
 */
const get = (request) => {
  let job = request.filter.puesto === undefined ? '' : `&puesto=${request.filter.puesto}`;
  let code = request.filter.codigo === undefined ? '' : `&codigo=${request.filter.codigo}`;
  let status = request.filter.estatus === undefined ? '' : `&estatus=${request.filter.estatus}`;
  let columns = request.filter.columnas === undefined ? '' : `&columnas=${request.filter.columnas}`;

  let URL = `${BASE_URL}/Puesto?paginado=0,0${job}${code}${status}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta el puesto de una empresa
 * @param {any} request IdPuesto
 * @return {any} promise
 */
const getById = (request) => {
  let URL = `${BASE_URL}/Puesto/${request}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Añade un puesto
 * @param {object} puesto
 * @return {any} promise
 */
const post = (puesto) => {
  let URL = `${BASE_URL}/Puesto`;

  return axios.post(URL, puesto).then(({ data }) => {
    return data;
  });
};

/**
 * Actualiza un puesto
 * @param {object} puesto
 * @return {any} promise
 */
const put = (puesto) => {
  let URL = `${BASE_URL}/Puesto/${puesto.IdPuesto}`;

  return axios.put(URL, puesto).then(({ data }) => {
    return data;
  });
};

export const JobService = {
  get,
  getById,
  post,
  put
};